import React from 'react';
import { connect } from "react-redux";
import {Grid} from "semantic-ui-react";
import VeritasHeader from "../../shared/VeritasHeader";
import {fetchAllOrganizations} from "../actions/DataProviderActions";
import DataProvidersTable from "./DataProvidersTable";
import {InlineLoading} from "../../../common/partials/Loading";
import DataProvidersSidebarFilters from "./DataProvidersSidebarFilters";
import Breadcrumb from '../../../common/partials/Breadcrumb';
import { setBreadCrumb } from '../../breadcrumb/BreadcrumbActions';
import Sidebar from "../../../common/components/Sidebar";
import VeritasSidebarButtons from "../../shared/VeritasSidebarButtons";

export class DataProvidersListPage extends React.Component {

    componentDidMount() {
        document.title = `Veritas - Data Providers`;
        // If the application reloads at this point, make an API call
        // to get all the providers so that for a possible navigation
        // directly to the Data Providers List page, the data is
        // loaded for rendering. This will also help in refreshing the list
        // if any edits are performed on the detail page.
        this.props.getAllOrganizations();
        this.props.setBreadCrumb({
            parent:  { url: '/veritas', text: 'Veritas' },
            list:    { url: '/veritas/data-providers', text: 'Data Providers' },
            service: { url: '', text: ''},
            source:  { url: '', text: ''},
        })
    }

    render() {
        return (
            <div className="veritas">
                <VeritasHeader />
                <Grid relaxed={true}>
                    <Grid.Column width={3}>
                        <Sidebar>
                            <VeritasSidebarButtons />
                            <div className="divider-background">
                                <hr />
                            </div>
                            <DataProvidersSidebarFilters />
                        </Sidebar>
                    </Grid.Column>
                    <Grid.Column width={13}>
                        <Breadcrumb />
                        {this.props.dp_filtered_state
                            ? (<DataProvidersTable DataProviders={this.props.filtered_all_organizations}/>)
                            : (<InlineLoading/>)
                        }
                    </Grid.Column>
                </Grid>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    all_organizations: state.veritas.providers.all_organizations,
    dp_filtered_state: state.veritas.providers.dp_filtered_state,
    filtered_all_organizations: state.veritas.providers.filtered_all_organizations,
});

const mapDispatchToProps = dispatch => ({
    getAllOrganizations: () => {dispatch(fetchAllOrganizations())},
    setBreadCrumb: (crumb) => {dispatch(setBreadCrumb(crumb))},
});


export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(DataProvidersListPage)
